import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

// "auto", not null — AutoComplete's watcher does `typeof modelValue === "object"`
// before `.value`, and `typeof null === "object"` in JS, so null crashes every button.
export default class ButtonIconSize extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId) => {
    let suffix = "px";
    const selectOptions = [
      { value: "auto", label: "Auto", secondaryLabel: "Text size" },
    ];

    if (themeId !== undefined) {
      themeStructure.size.icon.forEach(size => {
        let pixelValue = BaseOption._getStyleValuePropertiesFromTheme("size.icon", themeId)[size];

        selectOptions.push({
          value: size,
          label: camelToTitleCase(size),
          secondaryLabel: pixelValue,
        });

        if (optionValues["default.button-icon-size"] === size) {
          suffix = pixelValue;
        }
      });
    }

    return {
      label: "Icon Size",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        allowCustomValue: true,
        showAllResultsOnClick: true,
        suffix: suffix,
        items: selectOptions,
      },
    };
  };

  static defaultValue = "auto";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "auto" || configValue === null || configValue === undefined) {
      return null;
    }
    return configValue;
  }
}
